import React, {useState, useEffect} from 'react';
import * as S from './Incentive.styles';
import classnames from 'classnames';
import RewardProgressTable from './RewardProgressTable/RewardProgressTable';

import MypHeaderContainer from './MypHeaderContainer/MypHeaderContainer';

import FaqsNew from './../../stories/components/OnboardingNew/FooterBlock/FaqsNew/Faqs';
import FooterNew from './FooterNew/FooterNew';

import ErrorCard from './ErrorCard/ErrorCard';
import LineLoader from './Loader/Loader';
import megatron from '@ibibo/megatron';
import {getCookie} from '../../../../myaccount/src/utils/getCookie';

const Incentive = ({theme, history}) => {
  const ccdeCookie = getCookie('ccde');

  const [incentiveData, setIncentiveData] = useState({});
  const [isSticky, setIsSticky] = useState(false);
  const [errorData, setError] = useState({});
  const handleScroll = () => {
    if (window.scrollY >= 100) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };
  const country =
    Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' ||
    Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata'
      ? 'INDIA'
      : 'UAE';

  const fetchIncentiveData = async () => {
    const url = `${__ENV_CONFIG__.MYPARTNER}/agents/incentive-details/`;
    try {
      const response = await megatron({
        name: 'incentive details api',
        type: 'GET',
        url,
        credentials: 'include',
      });

      if (response?.data) {
        setIncentiveData(response);
        return;
      }

      setError({
        error: true,
        message: response?.message || 'Something Went Wrong. Please Try Again.',
      });
    } catch (err) {
      console.trace(err);
      setError({
        error: true,
        message: 'Something Went Wrong. Please Try Again.',
      });
      return false;
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    fetchIncentiveData();
  }, []);

  if (errorData && errorData?.error) {
    return (
      <ErrorCard
        src={'https://assets-gos3.goibibo.com/mmyp_incentive_error-1698389175.png'}
        errorTxt={'Uh Oh!'}
        errorSubtext={errorData?.message || 'It looks like our servers took too long'}
        errorImgClass={'serverErrorImg'}
      />
    );
  }
  if (!Object.keys(incentiveData).length) {
    return (
      <S.LoaderContainer className="mypLandingLoader">
        <LineLoader variant="MAX" customClass="loaderColor" />
      </S.LoaderContainer>
    );
  }

  const {data, error, message} = incentiveData || {};

  const {banner = {}, table = {}, faq = {}, header = {}, info = {}, pgOfferInfo = {}} = data || {};
  const {image = '', heading = {}, subHeading = {}, offer = {}, subHeadingImage = ''} =
    banner || {};

  return (
    <div>
      <MypHeaderContainer
        isSticky={isSticky}
        subText={`<span>${subHeading?.primaryText} <span class='latoBlack'>${subHeading?.secondaryText}</span></span>`}
        imgTxt={
          offer?.primaryText
            ? `<span class='latoBlack'> ${offer?.primaryText}</span>  ${offer.secondaryText} `
            : ''
        }
        imgSubTxt={offer?.subText}
        image={image}
        heading={heading}
        header={header}
        subHeadingImage={subHeadingImage}
      />
      <S.Body className="container appendBottom48">
        <div className="perfectCenter dirColumn">
          <S.InfoText className="infoText">{table?.heading}</S.InfoText>
          {table?.subHeading ? (
            <S.OfferText className="offerTxt">
              {ccdeCookie == 'AE' ? (
                <span>
                  <S.AEDImg src="https://assets-gos3.goibibo.com/myp_MYCASH_AED-1678423545.svg" />
                </span>
              ) : (
                <span className={classnames(table?.icon?.iconClasses)}></span>
              )}
              <span>{table?.subHeading}</span>
            </S.OfferText>
          ) : null}
        </div>
        <RewardProgressTable header={table?.header} data={table?.body} info={info} />
        {table?.summary ? (
          <S.SummaryText className="infoText">{table?.summary}</S.SummaryText>
        ) : null}
      </S.Body>
      {pgOfferInfo && (
        <S.Body className="container appendBottom48">
          <S.OfferHeading>{pgOfferInfo?.heading}</S.OfferHeading>
          {pgOfferInfo?.subHeading ? (
            <S.OfferSubHeading>
              <S.InrSymbol isAed={ccdeCookie == 'AE'}>
                {ccdeCookie == 'AE' ? 'AED' : '₹'}
              </S.InrSymbol>
              {pgOfferInfo?.subHeading}
            </S.OfferSubHeading>
          ) : null}
          <img src={pgOfferInfo?.bannerImage} />
          <img src={pgOfferInfo?.gccIncentiveImageUrl} />
          {pgOfferInfo?.btnURL && (
            <S.ContinueButton onClick={() => window.open(pgOfferInfo?.btnURL, '_self')}>
              {pgOfferInfo?.btnText}
            </S.ContinueButton>
          )}
        </S.Body>
      )}
      <FaqsNew
        heading={'Frequently Asked Questions'}
        faqData={faq?.data}
        faqHeadingData={[]}
        isFaqActive={true}
      ></FaqsNew>
      <FooterNew />
    </div>
  );
};

export default Incentive;
